import React, { useState } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Card,
  CardContent,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "Are the trading bonuses you offer withdrawable?",
    answer:
      "Trading bonuses are generally not directly withdrawable. They are provided to enhance your trading capacity and may become withdrawable only after meeting specific trading conditions.",
  },
  {
    question: "What happens to my bonus when I make an internal transfer or a withdrawal?",
    answer:
      "Bonuses may be reduced or removed proportionally when you withdraw funds or transfer between accounts, depending on the promotion terms.",
  },
  {
    question: "Is there a limit to the number of people I can refer?",
    answer:
      "No, there is typically no strict limit. You can refer multiple users and earn rewards based on the referral program structure.",
  },
  {
    question: "How can I participate in promotional offers?",
    answer:
      "You can participate by registering for available promotions through your account dashboard or by meeting the eligibility criteria.",
  },
  {
    question: "Do bonuses have an expiry date?",
    answer:
      "Yes, some bonuses may have a validity period. It is important to check the specific promotion terms for expiry details.",
  },
  {
    question: "Can I use bonus funds for trading?",
    answer:
      "Yes, bonus funds can usually be used to open and maintain trading positions, depending on the promotion rules.",
  },
  {
    question: "Can I combine multiple promotions?",
    answer:
      "This depends on the platform policy. Some promotions cannot be combined, while others may be used together under specific conditions.",
  },
  {
    question: "What happens if I violate promotion terms?",
    answer:
      "If promotion terms are violated, bonuses and any related profits may be canceled or adjusted as per the platform’s policy.",
  },
  {
    question: "How will I know about new promotions?",
    answer:
      "You will be notified through your account dashboard, email updates, or official announcements on the platform.",
  },
];

const Promotionfaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
      <>
      <Helmet>
        <link rel="canonical" href="https://www.hcfinvest.com/promotionfaq" />
      </Helmet>
            <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
        <ScrollToTopButton/>
      <Box
        sx={{
          position: "relative",
          height: "475px",
          display: "flex",
          flexDirection: "column", // 👈 Stack text vertically
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundImage: `url('Images/HelpCenterImages/Newhedgecapitalsimage_Helpcenter 1.jpg')`, // 👈 replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <h1
          variant="h3"
          component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Promotions
        </h1>

        {/* <Typography
          variant="h5"
          sx={{
            zIndex: 2,
            fontWeight: 500,
            px: 2,
          }}
        >
          Choose the Right Account to Match Your Trading Style
        </Typography> */}
      </Box>

      <Typography
        variant="h2"
        sx={{
          marginBottom: "50px",
          fontWeight: "600",
          fontSize: "2.5rem",
          color: "#101828",
        }}
      >
        FAQ
      </Typography>

      <Box sx={{ maxWidth: "1200px", margin: "40px auto" }}>
        {faqs.map((faq, index) => (
          <Card
            key={index}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleToggle(index)}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  {faq.question}
                </Typography>
                <IconButton>
                  <ExpandMoreIcon
                    sx={{
                      transform:
                        openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </IconButton>
              </Box>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Typography
                  variant="body1"
                  sx={{
                    mt: 2,
                    color: "text.secondary",
                    lineHeight: 1.7,
                    textAlign: "left",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
      </>
  );
};

export default Promotionfaq;
